import { hWebCrossUpperLeft, hWebCrossUpperLeft2, hWebCrossUpperRight } from '../lace/hWebCross'
import { topSidePartOfWeb } from './parts/sideParts'

export const onePeaceWeb2 = (ctx: CanvasRenderingContext2D, webColor: string, laceColor: string, stitchColor: string): void => {
  ctx.lineWidth = 1.0
  ctx.strokeStyle = '#282828'
  ctx.fillStyle = webColor
  // ウェブ本体
  ctx.beginPath()
  ctx.moveTo(194, 245) // 左＿左上
  ctx.quadraticCurveTo(225, 242, 230, 262) // 左上
  ctx.quadraticCurveTo(262, 253, 262, 253) // 中央＿左
  ctx.quadraticCurveTo(256, 299, 256, 299) // 左下＿上
  ctx.quadraticCurveTo(271, 320, 271, 330) // 左下＿下
  ctx.quadraticCurveTo(305, 250, 370, 210) // 右下＿下
  ctx.quadraticCurveTo(361, 168, 361, 168) // 右下＿上
  ctx.quadraticCurveTo(324, 177, 324, 177) // 中央＿右
  ctx.quadraticCurveTo(354, 104, 354, 104) //
  ctx.quadraticCurveTo(352, 87, 352, 68) // 右＿下
  ctx.quadraticCurveTo(351, 58, 343, 52) // 右＿上
  ctx.quadraticCurveTo(223, 110, 194, 245) // 右＿下
  ctx.fill()
  ctx.stroke()
  ctx.closePath()
  topSidePartOfWeb(ctx, webColor, laceColor, stitchColor)

  hWebCrossUpperLeft(ctx, laceColor, 0, 0) // クロス部分の右
  hWebCrossUpperRight(ctx, laceColor, 0, 0) // クロス部分の右
  hWebCrossUpperLeft2(ctx, laceColor, 0, 0) // クロス部分の左

  // stitchここから
  ctx.lineWidth = 1.2
  ctx.strokeStyle = stitchColor
  ctx.beginPath()
  ctx.setLineDash([3, 3])
  // ウェブ上部＿横ライン

  // 中央の四角_上辺
  ctx.moveTo(235, 256) // 左下
  ctx.quadraticCurveTo(273, 160, 350, 110) // 右上
  ctx.moveTo(239, 254) // 左下
  ctx.quadraticCurveTo(275, 165, 350, 114) // 右上

  // 中央の四角_右辺
  ctx.moveTo(347, 110) // 右上
  ctx.quadraticCurveTo(318, 182, 318, 182) // 左下
  ctx.quadraticCurveTo(357, 173, 357, 173) // 左下
  ctx.moveTo(342, 113) // 右上
  ctx.quadraticCurveTo(312, 185, 312, 185) // 左下
  ctx.quadraticCurveTo(332, 183, 353, 177) // 左下

  // 中央の四角_下辺
  ctx.moveTo(256, 297) // 右上
  ctx.quadraticCurveTo(277, 233, 358, 170) // 左下
  ctx.moveTo(258, 300) // 右上
  ctx.quadraticCurveTo(280, 240, 361, 173) // 左下

  // 中央の四角_左辺
  ctx.moveTo(234, 257) // 上
  ctx.quadraticCurveTo(265, 250, 265, 250) // 中央＿左
  ctx.quadraticCurveTo(259, 297, 259, 297) // 下
  ctx.moveTo(240, 252) // 上
  ctx.quadraticCurveTo(268, 245, 268, 245) // 中央＿左
  ctx.quadraticCurveTo(265, 280, 265, 280) // 下

  // 一番したの横ライン
  ctx.moveTo(266, 308) // 左上
  ctx.quadraticCurveTo(302, 233, 362, 196) // 右上
  ctx.moveTo(268, 312) // 左上
  ctx.quadraticCurveTo(304, 237, 364, 200) // 右上
  ctx.stroke()
  ctx.setLineDash([])
  ctx.closePath()
}
